import theme from '@ifca-root/react-component/src/assets/theme'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { SearchBar } from '@ifca-root/react-component/src/components/SpecialBar/SearchBar'
import SwitchBar from '@ifca-root/react-component/src/components/SpecialBar/SwitchBar'
import { useMediaQuery } from '@material-ui/core'
import { ExitConfirmationDialog } from 'components/Dialog/ExitConfirmationDialog'
import {
  useGetArIssueActualInvoiceListingLazyQuery,
  useGetArIssueProformaInvoiceListingLazyQuery,
  useGetArScheduledBillingbyStatusListingLazyQuery,
  useGetGenerateScheduledBillingListingLazyQuery,
  useGetUsersByAccountAndSoftwareQuery,
} from 'generated/graphql'
import { useFuseSearch } from 'helpers/Hooks/useSearch'
import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { IssuedProformaInvoiceEntryList } from './IssueProformaInvoice/IssueProformaInvoiceList/IssueProformaInvoiceEntryList'
import { IssueActualInvoiceEntryList } from './IssueActualInvoice/IssueActualInvoiceList/IssueActualInvoiceEntryList'

export const IssueActualInvoiceMain = (props: any) => {
  let history = useHistory()
  const getSearch = JSON.parse(localStorage.getItem('searchFilter'))
  const { CompanyID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  const approvalStatusEnum = [
    { name: 'Pending', ID: 'PENDING' },
    { name: 'Billed', ID: 'BILLED' },
  ]

  /* -------------------------------------------- */
  /*                     STATE                    */
  /* -------------------------------------------- */
  const [postIDs, setPostIDs] = useState<Set<any>>(new Set([]))
  const [openExitConf, setOpenExitConf] = useState(null)
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)

  const [listStatus, setListStatus] = useState<string>(
    getSearch?.option ?? 'PENDING'
  )

  /* -------------------------------------------- */
  /*                     QUERY                    */
  /* -------------------------------------------- */
  // for Sales Order Billing Schedule
  const [
    LoadARIssueActualInvoiceListing,
    {
      loading: getARIssueActualInvoiceListingLoading,
      data: { getARIssueActualInvoiceListing } = {
        getARIssueActualInvoiceListing: [],
      },
    },
  ] = useGetArIssueActualInvoiceListingLazyQuery({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    fetchPolicy: 'network-only',
    onCompleted: ({ getARIssueActualInvoiceListing }) => {
      if (getARIssueActualInvoiceListing?.Data?.length > 0) {
        setOriginalListing([
          ...filteredList,
          ...getARIssueActualInvoiceListing?.Data,
        ])
      }
    },
  })

  const {
    loading: UserLoading,
    data: { getUsersByAccountAndSoftware } = {
      getUsersByAccountAndSoftware: [],
    },
  } = useGetUsersByAccountAndSoftwareQuery({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    fetchPolicy: 'network-only',
  })

  /* ------------------------------------------ */
  /*                    VARIABLE                */
  /* ------------------------------------------ */
  const { filteredList, handleSearch, setOriginalListing } = useFuseSearch()

  const hasChanges = () => {
    if (postIDs?.size === 0) return false
    else return true
  }

  const [timer, setTimer] = useState(null)
  function changeDelay(change) {
    if (timer) {
      clearTimeout(timer)
      setTimer(null)
    }

    setTimer(
      setTimeout(() => {
        setOriginalListing([])
        LoadARIssueActualInvoiceListing({
          variables: {
            CompanyID,
            isBilled: listStatus === 'BILLED' ? true : false,
            take: 30,
            skip: 0,
            searchValue: change,
          },
        })
      }, 1000)
    )
  }

  useEffect(() => {
    setOriginalListing([])
    LoadARIssueActualInvoiceListing({
      variables: {
        CompanyID,
        isBilled: listStatus === 'BILLED' ? true : false,
        take: 30,
        skip: 0,
        searchValue:
          getSearch?.name !== '' || getSearch?.name === undefined
            ? undefined
            : getSearch?.name,
      },
    })
  }, [listStatus])

  return (
    <>
      {UserLoading && <Loading />}
      {getARIssueActualInvoiceListingLoading && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={() => {
          hasChanges() === true && listStatus === 'PENDING'
            ? setOpenExitConf(true)
            : history.push(`/account-receivable/${CompanyID}`)
          localStorage.removeItem(`searchFilter`)
        }}
        smTitle="Account Receivable"
        title={user?.companyName}
        routeSegments={[
          { name: 'Account Receivable' },
          { name: 'Issue Actual Invoice', current: true },
        ]}
      />
      <SwitchBar
        options={approvalStatusEnum}
        setOptionID={setListStatus}
        borderRadius="4px"
        defaultOption={approvalStatusEnum
          ?.map(opt => opt?.ID)
          .indexOf(listStatus ?? 'PENDING')}
        searchFilter={getSearch}
      />
      <div
        className="search-filter with-dropdown-filter"
        style={{ marginTop: isDesktop ? '-64px' : '0px', marginBottom: '-8px' }}
      >
        <SearchBar
          borderRadius="4px"
          onChangeAction={e => {
            localStorage.setItem(
              'searchFilter',
              JSON.stringify({
                option: listStatus ?? 'PENDING',
                name: e?.target?.value,
              })
            )
            changeDelay(e?.target?.value)
          }}
          isDefaultValue={!!getSearch}
          defaultValue={getSearch?.name ? getSearch?.name : ''}
          onCloseAction={() => {
            handleSearch('', [])
            setOriginalListing([])
            LoadARIssueActualInvoiceListing({
              variables: {
                CompanyID,
                isBilled: listStatus === 'BILLED' ? true : false,
                take: 30,
                skip: 0,
                searchValue:
                  getSearch?.name !== '' || getSearch?.name === undefined
                    ? undefined
                    : getSearch?.name,
              },
            })
            localStorage.removeItem('searchFilter')
          }}
        />
      </div>

      <IssueActualInvoiceEntryList
        filteredList={filteredList}
        getARIssueActualInvoiceListingLoading={
          getARIssueActualInvoiceListingLoading
        }
        listStatus={listStatus}
        userList={getUsersByAccountAndSoftware}
        fetchMore={LoadARIssueActualInvoiceListing}
        setOriginalListing={setOriginalListing}
        errMessage={errMessage}
        setErrMessage={setErrMessage}
        errDialog={errDialog}
        setErrDialog={setErrDialog}
        postIDs={postIDs}
        setPostIDs={setPostIDs}
      />

      <ExitConfirmationDialog
        openExitConf={openExitConf}
        setOpenExitConf={setOpenExitConf}
        onConfirm={() => {
          history.push(`/account-receivable/${CompanyID}`)
        }}
      />

      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
